import React from "react";
import order from "../images/order.PNG";
import submit from "../images/submit.PNG";

//NOTE: телефон в константы и в файл с константами

export default function InstructionsPopup({ isOpen, onClose }) {
  return (
    <div className={`popup ${isOpen ? "popup_opened" : ""}`}>
      <div className="popup__container">
        <button type="button" className="popup__close-btn" onClick={onClose} />
        <h2 className="popup__title">Instructions</h2>
        <div className="popup__instructions-content">
          <p>
            1. Select 1-2 portrait photos per person for the yearbook. Note that
            hard copy will be sold separately
          </p>
          <p>2. Select photos you want to print or receive as a digital file</p>
          <p>
            3. Click images to zoom and use ESC and arrow keys on you keyboard
            to easily flip through photos
          </p>
          <p>
            4. Click <img src={order} alt="order button" height="18px" /> at the
            top-right corner and then{" "}
            <img src={submit} alt="submit button" height="18px" /> to complete
            your purchase!{" "}
          </p>
          <p>
            5. If something does not work or you still have any questions,
            please call +7(985)8357632
          </p>
        </div>
        <button type="button" className="popup__submit-btn" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}

